import crud from '@/crud/index/index'

import data from './data'
import methods from './methods'

export default {
  data,
  methods,

  mixins: [crud],

  resourcePath: 'v1/search/professionals/abstractSpecialty'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/abstract-speciality/resources/index.js